(function() {
  'use strict';

  /* JS minimal : gère uniquement l'état sélectionné et le tooltip */
  function applySwatches() {
    var labels = document.querySelectorAll('[data-occifloc-color-label]');
    if (!labels.length) return;

    labels.forEach(function(label) {
      if (label.getAttribute('data-occifloc-init')) return;
      label.setAttribute('data-occifloc-init', 'true');

      var forId = label.getAttribute('for');
      var inp   = forId ? document.getElementById(forId) : label.previousElementSibling;
      if (!inp) return;

      var value = label.getAttribute('data-occifloc-color-label');
      label.setAttribute('data-tooltip', value);

      var optionName = inp.getAttribute('data-option');

      function getNameEl() {
        return document.querySelector('.js-swatch-label-name[data-swatch-name="' + optionName + '"]');
      }

      /* Nom au survol */
      label.addEventListener('mouseenter', function() {
        var nameEl = getNameEl();
        if (nameEl) nameEl.textContent = value;
      });
      label.addEventListener('mouseleave', function() {
        /* Remettre la couleur sélectionnée */
        var checked = document.querySelector('input[data-option="' + optionName + '"]:checked');
        var nameEl = getNameEl();
        if (nameEl && checked) nameEl.textContent = checked.value;
      });

      /* État initial */
      if (inp.checked) label.classList.add('is-selected');

      inp.addEventListener('change', function() {
        document.querySelectorAll('[data-occifloc-color-label]').forEach(function(l) {
          l.classList.remove('is-selected');
        });
        label.classList.add('is-selected');
        var nameEl = getNameEl();
        if (nameEl) nameEl.textContent = value;

      });
    });
  }

  function init() {
    applySwatches();

    /* Observer pour les re-renders Ultra */
    var target = document.querySelector('.js-product-options') || document.body;
    new MutationObserver(function() {
      applySwatches();
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 200); });
  } else {
    setTimeout(init, 200);
  }
})();
